import React from 'react'
import 'bootstrap'
import { Route, Redirect, Switch } from 'react-router-dom'
import AuthorizedLayout from './template/AuthorizedLayout'
import UnauthorizedLayout from './template/UnauthorizedLayout'
import BlankPage from './pages/BlankPage'
import UsersPage from './pages/UsersPage'
import OrdersPage from './pages/OrdersPage'
import UserEditPage from './pages/UserEditPage'
import UserDetailPage from './pages/UserDetailPage'
import AnalyticsPage from './pages/AnalyticsPage'
import AnalyticsEditPage from './pages/AnalyticsEditPage'
import ClientFunnelPage from './pages/ClientFunnelPage'
import ProFunnelPage from './pages/ProFunnelPage'
import TopProLinksPage from './pages/TopProLinksPage'
import StatisticPage from './pages/StatisticPage'
import LoginPage from './pages/LoginPage'
import NotFound from './pages/NotFound'
import store from './redux/store'

const App = (props) => {


  let loggedIn = (store.getState().auth.user != null)
  console.log(loggedIn)

  return (
    <Switch>
      <Route exact path="/" render={() => (
        // default route
        loggedIn ? (
          <Redirect to="/dashboard"/>
        ) : (
          <Redirect to="/login"/>
        )
      )}/>
      <Route path="/dashboard" render={props => (
        loggedIn ? (
          <AuthorizedLayout>
            <Switch>
              <Route exact path="/dashboard" render={() => (
                <Redirect to="/dashboard/users"/>
              )}/>
              <Route exact path="/dashboard/users" component={UsersPage}/>
              <Route exact path="/dashboard/users/:id/edit" component={UserEditPage}/>
              <Route exact path="/dashboard/users/:id/detail" component={UserDetailPage} />
              <Route exact path="/dashboard/analytics" component={AnalyticsPage}/>
              <Route exact path="/dashboard/analytics/client-funnel" component={ClientFunnelPage}/>
              <Route exact path="/dashboard/analytics/pro-funnel" component={ProFunnelPage}/>
              <Route exact path="/dashboard/analytics/top-pro-links" component={TopProLinksPage}/>
              <Route exact path="/dashboard/analytics/statistic" component={StatisticPage}/>
              <Route exact path="/dashboard/analytics" component={AnalyticsPage}/>
              <Route exact path="/dashboard/analytics/:id/edit" component={AnalyticsEditPage}/>
              <Route exact path="/dashboard/orders" component={OrdersPage}/>
              <Route component={NotFound}/>
            </Switch>
          </AuthorizedLayout>
        ) : (
          <Redirect to="/login"/>
        )
      )}/>
      <Route path="/" render={props => (
        <UnauthorizedLayout>
          <Switch>
            <Route exact path="/login" component={LoginPage}/>
            <Route exact path="/blank" component={BlankPage}/>
            <Route component={NotFound}/>
          </Switch>
        </UnauthorizedLayout>
      )}/>
    </Switch>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/App.js